"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var icon_1 = require("../../constants/img/icon");
var logo_1 = require("../../constants/img/logo");
var hooks_1 = require("preact/hooks");
var NavMenu_1 = require("../NavMenu/NavMenu");
var ga_1 = require("../../utils/ga");
var Header = function () {
    var _a = (0, hooks_1.useState)(false), open = _a[0], setOpen = _a[1];
    var handleSlide = (0, hooks_1.useCallback)(function (scrollValue) {
        var body = document.querySelector('body');
        if (Number.isFinite(scrollValue)) {
            body === null || body === void 0 ? void 0 : body.classList.add('js-menu-open');
            body === null || body === void 0 ? void 0 : body.setAttribute('style', "top:-".concat(scrollValue, "px"));
            setOpen(true);
        }
        else {
            // Restore the previous scroll value from body's style
            var scrollToValue = parseInt((body === null || body === void 0 ? void 0 : body.style.top) || '0', 10) * -1;
            // Remove attributes in body for stopping scroll
            body === null || body === void 0 ? void 0 : body.classList.remove('js-menu-open');
            body === null || body === void 0 ? void 0 : body.removeAttribute('style');
            // Scroll down to where it was before opening the cart after removing overlay: hidden
            window.scrollTo(0, scrollToValue);
            setOpen(false);
        }
    }, []);
    var handleClickAccount = function () {
        window.location.href = '/account';
    };
    var handleClickCart = function () {
        document.dispatchEvent(new Event('slideCart'));
    };
    return ((0, preact_1.h)("header", { class: "header__container" },
        (0, preact_1.h)("div", { class: "header" },
            (0, preact_1.h)("button", { class: "header__menu", onClick: function () {
                    handleSlide(window.scrollY);
                    (0, ga_1.sendEvent)('ce_open_nav');
                } },
                (0, preact_1.h)("img", { src: icon_1.HAMBURGER_ICON, alt: "hamburger icon" }),
                ' ',
                window.innerWidth >= 1025 ? 'Menu' : ''),
            (0, preact_1.h)("a", { class: "header__logo-container", href: "/" },
                (0, preact_1.h)("img", { alt: "O Positiv Health Logo", class: "header__logo", src: logo_1.OP_HEALTH_LOGO })),
            (0, preact_1.h)("div", { class: "header-account-cart" },
                (0, preact_1.h)("button", { class: "header__account hide-on-mobile", onClick: handleClickAccount },
                    (0, preact_1.h)("img", { src: icon_1.ACCOUNT_ICON, alt: "account icon" })),
                (0, preact_1.h)("button", { class: "header__cart", onClick: handleClickCart },
                    (0, preact_1.h)("img", { src: icon_1.CART_ICON, alt: "cart icon" }),
                    (0, preact_1.h)("p", { class: "header__quantity" })))),
        (0, preact_1.h)(NavMenu_1.default, { open: open, handleSlide: handleSlide })));
};
exports.default = Header;
